import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

const Card = ({ dog }) => {
  const { lenguage } = useSelector((s) => s);
  return (
    <>
      <div className="card_container">
        {/* <h4>{dog.id}</h4> */}
        <div className="second-bg"></div>
        <NavLink to={`/dogdetail/${dog.id}`}>
          <img src={dog?.image?.url} alt={dog.id} />
        </NavLink>
        <h3 className="name-card">{dog?.name}</h3>
        <div className="features">
          <h4 className="showdetails">{lenguage ? "Details" : "Detalles"}</h4>
          <div>
            <h3 className="temperaments-card">
              {lenguage ? "Temperaments" : "Temperamentos"}
            </h3>
            <p className="temps-card">
              {isNaN(dog.id)
                ? dog.Temperaments.map((t) => t.name).join(", ")
                : dog.temperament}
            </p>
          </div>
          <h3 className="temps-card">{lenguage ? "Weight" : "Peso"}</h3>
          <p>{dog.weight.metric}Kg </p>
        </div>
      </div>
    </>
  );
};

export default Card;
